import {Component, forwardRef, AfterViewInit, AfterContentChecked} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { RichAutocompleteModel } from '../rich-autocomplete.model';
import { CODE_WORKFLOW_COMPONENT } from 'src/app/app.models';

@Component({
    selector: 'abw-rich-autocomplete-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => RichAutocompleteFormComponent),
        multi: true
      }
    ],
    templateUrl: './rich-autocomplete-form.component.html',
    styleUrls: ['./rich-autocomplete-form.component.scss']
})
export class RichAutocompleteFormComponent extends AbstractWorkflowFormComponent<RichAutocompleteModel, string> implements AfterViewInit, AfterContentChecked {
    CODE_WORKFLOW_COMPONENT = CODE_WORKFLOW_COMPONENT;
    mentionConfig = {
        mentions: [
            {
                items: [],
                triggerChar: '@'
            },
            {
                items: [],
                triggerChar: '#'
            }
        ]
    };
    

    ngOnInit() {
        super.ngOnInit();
        this.datasourceComponentRefreshed = false;
        this.mentionConfig.mentions = [
            {
                triggerChar: '#',
                items: !!this.model && !!this.model.variablesEnvironnement ? this.model.variablesEnvironnement.map(v => `[${v.NOM_VARIABLE}]`).concat(this.model.fonctionsIds.map(c => `[${c.ID}]`)) : []
            },
            {
                triggerChar: '@',
                items: !!this.model && !!this.model.workflowComponents ? this.model.workflowComponents.map(c => `[${c.ID}]`) : []
            }
        ];
        
    }

    ngAfterViewInit() {
        this.datasourceComponentRefreshed = true;
        this._cdf.detectChanges();
    }

    ngAfterContentChecked() {
        this._cdf.detectChanges();
    }
}